import { OrganizationApiConfig } from 'types/organizations/organizationApiConfig';
import { trainApi } from '../cemitApis/trainApi/trainApiImplementation.ts';

const routes = trainApi?.routes
export const trainApiConfig : OrganizationApiConfig = {
  api: trainApi,
  routes
}
